module.exports = __webpack_public_path__ + "static/img/img1.7d37e288.png";